import * as React from 'react';
import { IconType, defaultBlackIcons, defaultErrorIcons, defaultGrayIcons, defaultWarningIcons } from './IconType';
import { IconSize } from './IconSize';
import styled, { ISpruceThemeProps } from 'styled-components';

interface IIconStyledProps {
  type: IconType;
  size?: IconSize;
  color?: string;
}

const swapColorForRealColor = (props: IIconStyledProps & ISpruceThemeProps): string => {
  if (props.color) {
    return props.color;
  }
  switch (true) {
    case defaultGrayIcons.includes(props.type):
      return props.theme.colors.darkGray;
    case defaultWarningIcons.includes(props.type):
      return props.theme.colors.warning;
    case defaultErrorIcons.includes(props.type):
      return props.theme.colors.error;
    case defaultBlackIcons.includes(props.type):
      return props.theme.colors.black;
    default:
      return props.theme.colors.primary;
  }
};

const appendIconSize = (type: IconType, size?: IconSize) => type === IconType.Upload && size === IconSize.Large;

const generateIconId = ({ size, type }: IIconProps) =>
  `#spruce-icon-${type}${appendIconSize(type, size) ? '-Large' : ''}`;

const IconStyled = styled.svg<IIconStyledProps>`
  width: ${(props) => props.size || IconSize.Regular};
  height: ${(props) => props.size || IconSize.Regular};
  color: ${swapColorForRealColor};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export interface IIconProps {
  className?: string;
  style?: React.CSSProperties;
  size?: IconSize;
  type: IconType;
  color?: string;
}

export const Icon: React.FC<IIconProps> = (props) => (
  <IconStyled {...props}>
    <use xlinkHref={generateIconId(props)} />
  </IconStyled>
);
